<template>
    <div class="solution-info-block">
        <div class="first-title">
            业务需求和挑战
        </div>
        <div class="content-info">
            <div class="info-introduction" v-for="item in dataVal.business[0].info">
                {{item}}
            </div>
            <div class="info-appeal" v-if="dataVal.business.length>1">
                <div class="appeal-show" v-for="item in dataVal.business[1].list">
                    <div class="info-title" v-if="item.title">
                        {{item.title}}
                    </div>
                    <div class="info-text" v-if="item.info">
                        {{item.info}}
                    </div>
                </div>
            </div>
        </div>
        <div class="first-title">
            解决方案
        </div>
        <div class="info-text">{{dataVal.programme[0].info}}</div>
        <img :src="dataVal.programme[0].image"/>
        <div class="first-title">
            {{dataVal.customerTitle}}
        </div>
        <div class="info-appeal">
            <div class="title-li-show" v-for="item in dataVal.customer">
                <div class="info-title" v-if="item.title">
                    {{item.title}}
                </div>
                <div class="info-text" v-if="item.info" v-for="items in item.info">
                    <li>{{items}}</li>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "solution-info-block",
        props:{
            dataVal:Object
        },
        created() {
            console.log(this.dataVal);
        }
    }
</script>

<style lang="scss" src="./solution-info-block.scss" scoped>

</style>
